// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"72":"a8dde086","377":"8b6f44aa","795":"eca773bc","827":"3d928ac7"}[chunkId] + ".js";
};